import React, { useState, useContext, useEffect } from "react";
import AppContext from "context/Context";
import { Accordion, Card, Col, Container, Form, Row, Tabs } from "react-bootstrap";
import FaqAccordionItem from "../faq/faq-accordion/FaqAccordionItem";
import { useTranslation } from "react-i18next";
import styles from "./landing.module.css";
import TabBox from "./TabBox";
import PageTitle from "components/common/PageTitle";
import { getAllDatabaseRecords, refreshWorkflowCounts } from "components/workflow/WorkflowHelper";
import Services from "./Services";
import * as Constants from "common/constants";
import { GetWorkflowsEndpoint } from "common/constants";
import { encryptStorage1, GetFaq, GetServiceDetails, GetServiceSteps, GetPageTitle } from "common/general";
import jwtDecode from "jwt-decode";
import { GetLoggedInUserData, LogoutUser } from "common/general";
import { startWorkflowProcess } from "components/workflow/StartWorkflowProcess";
import { useNavigate } from "react-router-dom";

document.addEventListener("DOMContentLoaded", function () {
	const cssToRemove = document.getElementById("css-to-remove");
	if (cssToRemove) {
		cssToRemove.parentNode.removeChild(cssToRemove);
	}
});
const AddFacilities = () => {
	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [t, i18n] = useTranslation();
	const [data, setData] = useState([]);
	const menuName = t(location?.state?.pagename);
	const [navItems, setNavItems] = useState([]);
	const navigate = useNavigate();
	const [faq, setFAQ] = useState([]);
	const [pageInfo, setPageInfo] = useState([]);
	const [serviceDetails, setServiceDetails] = useState([]);
	const storedLoggedInUserInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);

	const getTableData = async (tableName, fieldValue) => {
		try {
			const result = await getAllDatabaseRecords(tableName, fieldValue);
			return result;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	};
	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await GetServiceSteps(encodeURIComponent(location.pathname));

				if (response?.data?.dataBaseContent) {
					const mappedData = response.data.dataBaseContent.map((item) => ({
						id: item.id,
						title: t(item.title),
						description: t(item.description),
						order: item.order,
					}));
					const sortedData = mappedData.sort((a, b) => a.order - b.order);

					setNavItems(sortedData);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching service steps data:", error);
			}
			try {
				const response = await GetFaq(encodeURIComponent(location.pathname));

				if (response?.data?.dataBaseContent) {
					const mappedData = response.data.dataBaseContent.map((item) => ({
						id: item.id,
						title: t(item.title),
						description: t(item.description),
						order: item.order,
					}));
					const sortedData = mappedData.sort((a, b) => a.order - b.order);
					setFAQ(sortedData);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching faq data:", error);
			}
			try {
				const response = await GetServiceDetails(encodeURIComponent(location.pathname));

				if (response?.data?.dataBaseContent) {
					const mappedData = response.data.dataBaseContent.map((item) => ({
						id: item.id,
						title: t(item.title),
						description: t(item.description),
						icon: item.icon,
						order: item.order,
					}));
					const sortedData = mappedData.sort((a, b) => a.order - b.order);
					setServiceDetails(sortedData);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching service details data:", error);
			}
			try {
				const response = await GetPageTitle(encodeURIComponent(location.pathname));

				if (response?.data?.dataBaseContent) {
					const mappedData = response.data.dataBaseContent.map((item) => ({
						id: item.id,
						title: t(item.title),
						workflowKey: t(item.workflowKey),
						PDF: t(item.PDF),
						key: t(item.key),
					}));
					setPageInfo(mappedData[0]);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching page title data:", error);
			}
		};

		fetchData();
	}, [t]);

	const startProcess = async (processId) => {
		//await db.table("temp_form_data").clear();

		// localStorage.removeItem("TempFormData")
		startWorkflowProcess(processId, true)
			.then(async (formData) => {
				localStorage.setItem(Constants.CurrentWorkflowStep, JSON.stringify(formData));
				navigate("/form_view_renderer", { state: { data: formData } });
				await refreshWorkflowCounts();
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const [fetchFlag, setFetchFlag] = useState(false);
	useEffect(() => {
		async function fetchData() {
			try {
				var accessToken = encryptStorage1.getItem(Constants.AccessTokenKeyInLocalStorage);
				const decodedAccessToken = jwtDecode(accessToken);
				var userData = await GetLoggedInUserData();
				const hasClonePermission = Object.values(userData.userCompanyDictionary)
					.flat()
					.some((companyRole) => companyRole.permissionResponseList.some((permission) => permission.actionsResponseDTO?.some((action) => action.actionId === "cloneWorkflow")));

				var selectedCompany = encryptStorage1.getItem(Constants.SelectedCompany);
				const response = await fetch(GetWorkflowsEndpoint + "?userId=" + decodedAccessToken.sub + "&companyId=" + selectedCompany, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + accessToken,
					},
				});

				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}

				const responseText = await response.text();

				if (!responseText) {
					throw new Error("Received empty response from the server.");
				}

				try {
					const newData = JSON.parse(responseText);
					let arrayOfWorkflows = Object.values(newData.workflowsResponseList);
					const pendingTasks2 = arrayOfWorkflows.flatMap((task) => {
						let parsedTask;
						try {
							parsedTask = typeof task === "string" ? JSON.parse(task) : task;
						} catch (e) {
							console.error("Error parsing task:", task, e);
							return [];
						}
						if (parsedTask.key === pageInfo?.key) {
							parsedTask.name = t(parsedTask.name);
							parsedTask.action = (
								<button key={parsedTask.id} className={`${styles.greenStyleBigButton}`} onClick={() => startProcess(parsedTask.id)}>
									{t("→ Start Service ")}
								</button>
							);
							return parsedTask;
						}
						return []; // skip tasks that don't match
					});
					if (newData.httpResponse.status === 0) {
						toast.error(newData.httpResponse.message, { autoClose: 3000 });
					} else {
						setData(pendingTasks2);
					}
				} catch (jsonError) {
					console.error("Response text:", responseText);
				}
			} catch (networkError) {
				console.error("Fetch error:", networkError);
			}
			//}
		}

		if (storedLoggedInUserInfo) {
			fetchData();
		}
	}, [pageInfo]);
	return (
		<div className={`${styles.backgroundWhite}`}>
			<Container className={`${styles.padding35em} ${styles.addPageHeight} `}>
				<PageTitle menuName={menuName} />
				<Row>
					<Col xs={12} md={9}>
						{t(pageInfo?.title)}
					</Col>
					<Col xs={12} md={3}>
						{data.map((item) => item.action)}
						<a href={pageInfo?.PDF} download target="_blank" rel="noopener noreferrer" className={` ${styles.whiteStyleBigButton}`}>
							{t("Download the user manual")}
						</a>
					</Col>
				</Row>
				<Row className="mb-2 lign-items-stretch">
					<Col xs={12} md={8} className="d-flex">
						<div className="card flex-fill">
							<div className="card-body">{navItems.length > 0 && <TabBox navItems={navItems} />}</div>
						</div>
					</Col>
					<Col xs={12} md={4} className="d-flex">
						<div className="card flex-fill">
							<div className="card-body">
								<div className={`${styles.serviceTitle}`}>{t("Service details")}</div>
								<div className={`${styles.serviceTitle1}`}>{t("Find out more details")}</div>
								{serviceDetails.map((item, index) => (
									<Services key={index} item={item} />
								))}
							</div>
						</div>
					</Col>
				</Row>
				<div className="card">
					<div className="card-body">
						<h2 className={`mb-2`}>{t("FAQ")}</h2>
						<Accordion id="accordionFaq" className="overflow-hidden">
							{faq.map((item) => (
								<FaqAccordionItem key={item.id} id={item.id} title={t(item.title)} description={`${t(item.description)}`} isFirst={true} isLast={false} />
							))}
						</Accordion>
					</div>
				</div>
			</Container>
		</div>
	);
};

export default AddFacilities;
